import * as React from "react";
import Chart from "components/Dashboard/Chart";
import { useState, useEffect } from "react";
import { ChartHeader, ChartFooter } from "components/Dashboard";
import billing from "../../assets/DashboardIcons/billing.svg";
import Unbilled from "../../assets/DashboardIcons/unbilled.svg";
import { AmountFormat } from "components/common/formatter";
import styles from "./DashboardPage.module.scss";
import { useDashboardData } from "services/dashboardService";

export const BillingTargetChart = ({ filters }) => {
  const initialSeries = [
    { name: "Bill Recorded", data: [] },
    { name: "Target", data: [] },
  ];
  const [series, setSeries] = useState(initialSeries);
  const [categories, setCategories] = useState([]);

  const { data: dashboardData, loading } = useDashboardData();
  const billingTarget = dashboardData?.billing;

  useEffect(() => {
    if (billingTarget?.data && Array.isArray(billingTarget.data)) {
      const cats = [];
      const updatedSeries = initialSeries.map((s) => ({ ...s, data: [] }));

      billingTarget.data.forEach((item) => {
        cats.push(item.key);
        updatedSeries[0].data.push(item.actual ?? 0);
        updatedSeries[1].data.push(item.target ?? 0);
      });

      setCategories(cats);
      setSeries(updatedSeries);
    } else {
      setCategories([]);
      setSeries(initialSeries);
    }
  }, [billingTarget?.data]);

  if (loading) {
    return (
      <div className="h-100 p-2">
        <ChartHeader
          name="Billing"
          type="(Actual vs Targets)"
          param1="Billed"
          param2="Target"
          icon={billing}
          color="#E2FFF4"
          duration={filters?.duration}
        />
        <div className="h-100 p-2 d-flex align-items-center justify-content-center">
          <div className="text-muted">Loading billing data...</div>
        </div>
      </div>
    );
  }

  return (
    <div className="h-100 p-2">
      <ChartHeader
        name="Billing"
        type="(Actual vs Targets)"
        param1="Billed"
        param2="Target"
        icon={billing}
        color="#E2FFF4"
        duration={filters?.duration}
      />
      {loading ? (
        <div className="h-100 p-2 d-flex align-items-center justify-content-center">
          <div className="text-muted">Loading billing data...</div>
        </div>
      ) : (
        <>
          <div className="p-2">
            <Chart
              series={series}
              onSeriesClick={() => {}}
              categories={categories}
            />
          </div>
          <ChartFooter param1="Billed" param2="Target" data={series} />
        </>
      )}
    </div>
  );
};

export const BillingTargetStatsCard = () => {
  const { data: dashboardData, loading } = useDashboardData();
  const billingTarget = dashboardData?.billing;

  const totalBilling =
    billingTarget?.data?.reduce((sum, item) => sum + (item.actual ?? 0), 0) ||
    0;
  const totalTarget =
    billingTarget?.data?.reduce((sum, item) => sum + (item.target ?? 0), 0) ||
    0;

  return (
    <div className="d-flex flex-column align-items-start mt-4 py-3 px-4">
      <div
        className={styles.iconContainer}
        style={{ backgroundColor: "#E2FFF4" }}
      >
        <img src={billing} alt="billingIcon" />
      </div>
      <p className="fs-md fw-semibold mt-1 mb-1" style={{ color: "#0ACF83" }}>
        Billing
      </p>
      {loading ? (
        <span className="text-muted">Loading...</span>
      ) : (
        <p className="fs-lg fw-bold">£{AmountFormat(totalBilling)} <span style={{ color: "#898989"}}> / £{AmountFormat(totalTarget)}</span></p>
      )}
    </div>
  );
};

export const UnBilledTargetStatsCard = () => {
  const { data: dashboardData, loading } = useDashboardData();
  const timeTarget = dashboardData?.time;
  const billingTarget = dashboardData?.billing;

  const totalTime =
    timeTarget?.data?.reduce((sum, item) => sum + (item.actual ?? 0), 0) || 0;
  const totalBilling =
    billingTarget?.data?.reduce((sum, item) => sum + (item.actual ?? 0), 0) ||
    0;

  return (
    <div className="d-flex flex-column align-items-start mt-4 py-3 px-4">
      <div
        className={styles.iconContainer}
        style={{ backgroundColor: "#FFF4E5" }}
      >
        <img src={Unbilled} alt="unbilledIcon" />
      </div>
      <p className="fs-md fw-semibold mt-1 mb-1" style={{ color: "#FF9E16" }}>
        Unbilled
      </p>
      {loading ? (
        <span className="text-muted">Loading...</span>
      ) : (
        <p className="fs-lg fw-bold">
          £{AmountFormat(totalTime - totalBilling)}
        </p>
      )}
    </div>
  );
};
